/**Author: Jimmy Patel
 * 
 * Created: 19 August, 2023
 * Pasted On Shopify: 27 May, 2025
 * 
 */

let product_summary = document.querySelectorAll(".product_summary");

product_summary.forEach(product_summary => {
  product_summary.addEventListener("click", event => {
    const active = document.querySelector(".product_summary.active");
    if(active && active !== product_summary ) {
      active.classList.toggle("active");
      active.nextElementSibling.style.maxHeight = 0;
    }
    product_summary.classList.toggle("active");
    const content = product_summary.nextElementSibling;
    if(product_summary.classList.contains("active")){
      content.style.maxHeight = content.scrollHeight + "px";
    } else {
      content.style.maxHeight = 0;
    }
  })
})

/* to remove red * from comment of review
*(filter already added in function.php file to allow empty comment on submiting review. But still required mark of * was there. Here, with the help of js, we have removed whole <span class="required">*</span> element ) */
window.onload = function() {
var commentRequired = document.querySelector('.comment-form-field-textarea .required');
	if(commentRequired)
		commentRequired.parentNode.removeChild(commentRequired);
};